"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getLocaleFromHeaders = exports.getLocaleFromAcceptLanguageHeader = exports.ACCEPT_LANGUAGE_HEADER = void 0;
const utils_1 = require("./utils");
const accept_language_parser_1 = __importDefault(require("accept-language-parser"));
exports.ACCEPT_LANGUAGE_HEADER = "accept-language";
const MISSING_REGION_MAP = {
    en: "US",
    es: "ES",
    de: "DE",
    fr: "FR",
    it: "IT",
    nl: "NL",
    pt: "PT",
};
const getLocaleFromAcceptLanguageHeader = (acceptLanguageHeader) => {
    const parsedLanguages = accept_language_parser_1.default.parse(acceptLanguageHeader);
    const localeList = parsedLanguages.map((language) => {
        const languageCode = language.code.toLowerCase();
        const regionCode = language.region ? language.region.toUpperCase() : "";
        return regionCode ? `${languageCode}_${regionCode}` : `${languageCode}_${MISSING_REGION_MAP[languageCode]}`;
    });
    let headerLocale = null;
    localeList.forEach((locale) => {
        if (!headerLocale && (0, utils_1.isSupportedLocale)(locale)) {
            headerLocale = locale;
        }
    });
    return headerLocale;
};
exports.getLocaleFromAcceptLanguageHeader = getLocaleFromAcceptLanguageHeader;
const getLocaleFromHeaders = (headers) => {
    const acceptLanguageHeader = headers[exports.ACCEPT_LANGUAGE_HEADER];
    return (0, exports.getLocaleFromAcceptLanguageHeader)(acceptLanguageHeader);
};
exports.getLocaleFromHeaders = getLocaleFromHeaders;
//# sourceMappingURL=headers.js.map